<template>
  <svg width="100%" height="100%" style="">
    <!-- <symbol id="marker" viewBox="-13 -22 26 40">
        <path d="M -10 15 L 0 -15 L 10 15 z" />
    </symbol> -->
    <use xlink:href="#marker"/>
    <g style="transform: translate(0, 0)">
        <path :d="line" />
        <path :d="line3" />
        <path id="savings" :d="line2" />
        <g v-for="w in wind" :transform="`translate(${w.x},${w.speed}) rotate(${w.angle})`">
            <path d="M -5 7.5 L 0 -7.5 L 5 7.5 z" class="marker"/>
        </g>
    </g>
  </svg>
</template>
<!-- 
Wind direction
Relative wind direction
Apparent wind direction
Distance
Power with
Power without
FOC with
FOC without
Rotor speed



-->
<script>
import * as d3 from 'd3';
export default {
  name: 'RouteChart',
  props: {
    segments: Array,
    windRange: Number,
    month: Number,
    savings: Array,
  },
  data() {
    return {
      data: [99, 71, 78, 25, 36, 92],
      size: [0,0]
    };
  },
  mounted() {
    this.$nextTick(function() {
        window.addEventListener('resize', this.onResize);
    })
  },
  methods: {
    getScales() {
      const x = d3.scaleTime().range([0, this.size[0]]);
      const y = d3.scaleLinear().range([this.size[1], 0]);
      d3.axisLeft().scale(x);
      d3.axisBottom().scale(y);
      x.domain([0, d3.max(this.segments, d => d.distCum)]);
      y.domain([0, 15]);
      return { x, y };
    },
    getScales2() {
      const x = d3.scaleTime().range([0, this.size[0]]);
      const y = d3.scaleLinear().range([this.size[1], 0]);
      d3.axisLeft().scale(x);
      d3.axisBottom().scale(y);
      x.domain([0, d3.max(this.segments, d => d.distCum)]);
      y.domain([-0.1, 1]);
      return { x, y };
    },
    onResize(event) {
        this.$set(this.size, 0, this.$el.clientWidth);
        this.$set(this.size, 1, this.$el.clientHeight);
    },
    getSavings(windSpeed,windDirection){
      var i = Math.round(windSpeed/2);
      var j = Math.round(((windDirection+720) % 360)/15) % 24;
      return this.savings[i][j]
    }
  },
  computed: {
      // axis: function() {
      //   const scale = this.getScales();
      //   var axis = d3.axisBottom(scale.x);
      //   console.log(axis(null));
      //   return null
      // },
      line: function() {
      const scale = this.getScales();
      const path = d3.line()
        .x(d => scale.x(d.distMid))
        .y(d => scale.y(Math.sqrt(this.windData[2*this.month*this.windRange+d.cell]*this.windData[2*this.month*this.windRange+d.cell]+this.windData[(2*this.month+1)*this.windRange+d.cell]*this.windData[(2*this.month+1)*this.windRange+d.cell])));
        return path(this.segments);
      },
      line2: function() {
        if (!this.savings) return ""

      const scale = this.getScales2();
      var self = this
      const path = d3.line()
        .x(d => d.x)
        .y(d => scale.y(self.getSavings(Math.sqrt(d.u*d.u+d.v*d.v),d.angle)));
        return path(this.wind);
      },
      line3: function() {
        if (!this.savings) {
          return ""
        }
      const scale = this.getScales2();
      var self = this
      const path = d3.line()
        .x(d => d.x)
        .y(d => scale.y(0));
        return path(this.wind);
      },
      windData: function () {
            return this.$root.$children[0].$options.windData
        },
      wind: function () {
          var wind = [];
          var u,v,angle;
          const scale = this.getScales();
          for (var i=0; i<this.segments.length;i++){
              u = this.windData[2*this.month*this.windRange+this.segments[i].cell]
              v = this.windData[(2*this.month+1)*this.windRange+this.segments[i].cell]
              angle = Math.atan2(u,v)/Math.PI*180.0-this.segments[i].bearing;
              wind.push({x: scale.x(this.segments[i].distMid), u: u, v: v, speed: scale.y(Math.sqrt(u*u+v*v)), angle:angle})
          }
          return wind
      }
  },
  beforeUpdate() {
    this.onResize(null);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
  }
};
</script>

<style scoped>
svg {
  margin: 0;
}
.marker {
  fill: rgb(56, 77, 172);
  stroke: none;
  /* stroke-width: 3px; */
}
path {
  fill: none;
  stroke: rgb(56, 77, 172);
  stroke-width: 1px;
}
path#savings {
  fill: none;
  stroke: rgb(42, 150, 65);
  stroke-width: 3px;
}
</style>